// src/components/InstallGuide.jsx
// "Install the app" on iPhone and iPad (3.52.0): Apple lets websites be
// installed only from the Share menu, so this shows the three taps.
import MenuDialog from './MenuDialog';

const ShareIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="the Share button" style={{ verticalAlign: '-3px' }}>
    <path d="M12 3v12" /><path d="M8 7l4-4 4 4" /><path d="M6 11H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1" />
  </svg>
);

export default function InstallGuide({ onClose }) {
  return (
    <MenuDialog id="install-app" icon="📲" title="Install the Fax Portal app" sub="Put CP Fax Portal on your Home Screen, like any other app." onClose={onClose} width={460}>
      <div style={S.top}>
        <img src={`${process.env.PUBLIC_URL}/icons/icon-192.png`} alt="" style={S.icon} />
        <div><div style={S.name}>CP Fax Portal</div><div style={S.muted}>Crazy Pixels Fax Portal</div></div>
      </div>
      <ol style={S.steps}>
        <li>Tap the Share button <span style={S.share}><ShareIcon /></span> (at the bottom of Safari, or at the top right in Chrome).</li>
        <li>Scroll down and tap <strong>Add to Home Screen</strong>.</li>
        <li>Tap <strong>Add</strong>. The CP Fax Portal icon appears on your Home Screen.</li>
      </ol>
      <p style={S.muted}>From then on, open the Fax Portal from that icon. You stay signed in, it opens full screen, and it updates by itself.</p>
      <div style={{ textAlign: 'right', marginTop: 14 }}><button onClick={onClose} style={S.btn}>Got it</button></div>
    </MenuDialog>
  );
}

const S = {
  top: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 },
  icon: { width: 56, height: 56, borderRadius: 13, boxShadow: '0 2px 8px rgb(var(--c-000000-rgb) / 0.15)' },
  name: { fontSize: 16, fontWeight: 700, color: 'var(--t-263238)' },
  muted: { fontSize: 13, color: 'var(--t-607d8b)', lineHeight: 1.5, margin: 0 },
  steps: { margin: '0 0 12px', paddingLeft: 22, fontSize: 14.5, lineHeight: 1.7, color: 'var(--t-37474f)' },
  share: { display: 'inline-flex', padding: '1px 5px', borderRadius: 6, border: '1px solid var(--c-b2dfdb)', color: 'var(--t-1565c0)', background: 'var(--c-f0faf8)' },
  btn: { padding: '9px 18px', borderRadius: 10, border: 'none', background: 'var(--c-00695c)', color: 'var(--t-ffffff)', fontWeight: 700, fontSize: 14, fontFamily: 'inherit', cursor: 'pointer' },
};
